import React, { useState, useRef } from 'react';
import axios from 'axios';

import "./FormularView.css";
import ProgressBar from './ProgressBar';




const isValidFileUploaded=(file)=>{
    const validExtensions = ['png','jpeg','jpg']
    const fileExtension = file.type.split('/')[1]
    return validExtensions.includes(fileExtension)
}

function FormularView({SelectedQuestion}) {
    const hiddenFileInput = useRef(null);
    const valueSelectedQuestion = SelectedQuestion.toString();
    const [isLoading, setIsLoading] = useState(false);
    const [sendDataSuccess, setSendDataSuccess] = useState(false);
    const [selectedImage, setSelectedImage] = useState();
    const [errors, setErrors] = useState({});
    const [formData, setFormData] = useState({
        name: "",
        firstname: "",
        zip: "",
        place: "",
        email: "",
        phone: "",
        message: "",
        file: "",
        subject: valueSelectedQuestion
    })

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({...formData, [name]: value});
        setErrors({ ...errors, [name]: "" });
    }
    
    const handleSubmit = (e) => {
        e.preventDefault();
        const validationErrors = {};
        const formDataObj = new FormData();

        
        if (formData.name.trim() === "") {
            validationErrors.name = "Bitte ausfüllen!";
        }

        if (formData.firstname.trim() === "") {
            validationErrors.firstname = "Bitte ausfüllen!";
        }
        

        if (formData.zip.trim() === "") {
            validationErrors.zip = "Bitte ausfüllen!";
        }

        if (formData.place.trim() === "") {
            validationErrors.place = "Bitte ausfüllen!";
        }

        if (formData.email.trim() === "") {
            validationErrors.email = "Bitte ausfüllen!";
        }
        if (formData.phone.trim() === "") {
            validationErrors.phone = "Bitte ausfüllen!";
        }

        if (selectedImage) {
            formDataObj.append("file", selectedImage);
        }

        formDataObj.append('name', formData.name);
        formDataObj.append('firstname', formData.firstname);
        formDataObj.append('email', formData.email);
        formDataObj.append('phone', formData.phone);
        formDataObj.append('zip', formData.zip);
        formDataObj.append('place', formData.place);
        formDataObj.append('message', formData.message);


        formDataObj.append('subject', formData.subject);

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
        }else{
            setIsLoading(true);
            axios({
                method: 'post',
                url: '/backend/send.php',
                headers: {'Content-Type': 'multipart/form-data' },
                data: formDataObj
            }).then((response) => {
                if (response.status == '200') {
                    //document.querySelector(".success").style.cssText = "display: block; text-align: center;";
                    setSendDataSuccess(true);
                    document.body.className += ' app-end';
                    //window.scrollTo(0, 0);

                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        'event': 'rsmFormStep',
                        'rsmStepNumber': '2',
                        'rsmStepName': 'Kontaktdaten',
                        'rsmStepType': 'conversion',
                        'rsmEmail': formData.email,
                        'rsmZip': formData.zip
        
                    });

                
                }else{
                    console.log('Nein');
                }
            }).catch((error) => {
                console.log('Error submittig from:', error);
                setIsLoading(false);
            })
            console.log(formData);

            console.log('end');
            return false;

        }

    }

    const uploadHandleClick = (e) => {
        hiddenFileInput.current.click();
        console.log(formData);
    }


    const fileIsChange  = (e) => {
        console.log(formData.file.name);
    }


    const handleFileChange = async (e) => {



        console.log(e);


        if(e.target.files.length < 1){
            return;
        }
        const file = e.target.files;
        if(isValidFileUploaded(file[0])){
            setSelectedImage(file[0]);
            setFormData({...formData, file: file[0]});
        }else{
            console.log('failed');
        }

        if(!file){
            return;
        }
        try {
            const imgUrl = await file?.[0];
            console.log('Upload Success: ' + imgUrl);
        } catch(error) {
            console.log(error);
        }
    }



    return (
        <div className="form-wrap">
            {!sendDataSuccess && 
                <>
                <ProgressBar />
                <div className="question-headline">
                Ihre Kontaktdaten
                </div>  
                </>
            }  
            <form onSubmit={handleSubmit}>
                {sendDataSuccess && <div className="success display-none">Vielen Dank für Ihre Anfrage ­- wir melden <br/>uns schnellstmöglich bei Ihnen!</div>}
                {!sendDataSuccess &&
                <>
                <div className="form-input-handler">
                    <div className="form-input-item form-input-item-row-2">
                        <div className="item-handler">
                            <input 
                                type="text"
                                id="firstname"
                                className={`full-width ${formData.firstname ? "input-is-fill" : null}`}
                                name="firstname"
                                value={formData.firstname}
                                onChange={handleInputChange}
                            />
                            <label htmlFor="firstname">Vorname*
                            {errors.firstname && (
                                <span className="validation-message">{errors.firstname}</span>
                            )}
                            </label>
                        </div>
                        <div className="item-handler">
                            <input 
                                type="text"
                                id="name"
                                className={`full-width ${formData.name ? "input-is-fill" : null}`}
                                name="name"
                                value={formData.name}
                                onChange={handleInputChange}
                            />
                            <label htmlFor="name">Name*
                            {errors.name && (
                                <span className="validation-message">{errors.name}</span>
                            )}
                            </label>
                        </div>
                    </div>
                    <div className="form-input-item form-input-item-row-2">
                        <div className="item-handler">
                            <input 
                                type="text"
                                id="zip"
                                className={`full-width ${formData.zip ? "input-is-fill" : null}`}
                                name="zip"
                                value={formData.zip}
                                onChange={handleInputChange}
                            />
                            <label htmlFor="zip">Postleitzahl*
                            {errors.zip && (
                                <span className="validation-message">{errors.zip}</span>
                            )}
                            </label>
                        </div>



                        <div className="item-handler">
                            <input 
                                type="text"
                                id="place"
                                className={`full-width ${formData.place ? "input-is-fill" : null}`}
                                name="place"
                                value={formData.place}
                                onChange={handleInputChange}
                            />
                            <label htmlFor="place">Ort*
                            {errors.place && (
                                <span className="validation-message">{errors.place}</span>
                            )}
                            </label>
                        </div>


                    </div>

                    <div className="form-input-item form-input-item-row-2">
                        <div className="item-handler">
                                <input 
                                    type="text" 
                                    id="name" 
                                    className={`full-width ${formData.phone ? "input-is-fill" : null}`}
                                    name="phone" 
                                    value={formData.phone} 
                                    onChange={handleInputChange} 
                                />                             
                                <label htmlFor="phone">
                                Telefonnummer*{" "}
                                {errors.phone && (
                                    <span className="validation-message">{errors.phone}</span>
                                )}
                                </label>
                            </div>

                            <div className="item-handler">
                                <input 
                                    type="email" 
                                    id="email" 
                                    className={`full-width ${formData.email ? "input-is-fill" : null}`}
                                    name="email" 
                                    value={formData.email} 
                                    onChange={handleInputChange} 
                                />
                                <label htmlFor="email">E-Mail*
                                {errors.email && (
                                    <span className="validation-message">{errors.email}</span>
                                )}
                                </label>                        
                            </div>
                        </div>
                    <div className="form-input-item form-input-item-row-full">
                        <div className="item-handler">
                            <textarea 
                                type="text" 
                                id="message" 
                                className={`full-width ${formData.message ? "input-is-fill" : null}`}
                                name="message" 
                                value={formData.message} 
                                onChange={handleInputChange} 
                            />
                            <label htmlFor="message">Ihre Nachricht
                            {errors.message && (
                                <span className="validation-message">{errors.message}</span>
                            )}
                            </label>
                        </div>
                    </div>
                    <div className="form-input-item form-input-item-row-2">
                        <div className="upload-wrap item-handler">
                            <label htmlFor="message">
                                Optional: Foto hochladen (jpg, gif, png):{" "}
                            </label>
                            <div className="upload-box">
                                <input 
                                    type="file" 
                                    onChange={handleFileChange} 
                                    ref={hiddenFileInput}
                                    accept="image/*" 
                                    />
                            </div>
                        </div>
                        <div className="item-handler submit-handler">
                            <button
                                type="submit"
                                disabled={isLoading}
                                className="next-btn"
                            >
                                Absenden
                            </button>
                        </div>
                    </div>

                    <div className="form-input-item form-input-item-row-full">
                        <div className="item-handler">

                        <div className="datenschutz">
                            Mit * gekennzeichnete Felder sind Pflichtfelder.<br></br> Bitte beachten Sie unsere <a href="https://glasbau-brehm.de/impressum" target="_blank">Datenschutzerklärung.</a>
                        </div>

                        </div>
                    </div>



                </div>
                </>
                }
            </form>
        </div>
    )
}

export default FormularView
